import { render, staticRenderFns } from "./PositionManagement.vue?vue&type=template&id=46dbb5f4&scoped=true"
import script from "./PositionManagement.vue?vue&type=script&lang=js"
export * from "./PositionManagement.vue?vue&type=script&lang=js"
import style0 from "./PositionManagement.vue?vue&type=style&index=0&id=46dbb5f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dbb5f4",
  null
  
)

export default component.exports